import { ref } from 'vue'

const categoryNames = {
  all: 'hotel_offers_tab_all',
  perks: 'hotel_offers_tab_perks',
  guest_experience: 'hotel_offers_tab_experience',
  vouchers: 'hotel_offers_tab_vouchers',
  package: 'hotel_offers_packages_tab',
}
const isRemoveOfferOpen = ref(false)
const createOfferMode = ref(null)
const isCreateOfferOpen = ref(false)
const selectedOffer = ref(null)
const newOfferModalSource = ref(null)
const suggestionsModalSource = ref(null)
const isSuggestionsOpen = ref(false)

export function useHotelOffers() {
  const openRemoveOfferModal = () => {
    isRemoveOfferOpen.value = true
  }
  const closeRemoveOfferModal = () => {
    isRemoveOfferOpen.value = false
  }

  const selectOffer = (offerName, templates) => {
    const currentOffer = templates.value?.find(item => {
      return item.name === offerName
    })
    selectedOffer.value = currentOffer || null
  }

  const openEditOffer = (activeOffer, templates) => {
    createOfferMode.value = 'edit'
    if (activeOffer.template !== null) {
      selectOffer(activeOffer.template, templates)
    }
    isCreateOfferOpen.value = true
  }

  const closeCreateOfferOpen = switchingModals => {
    if (!switchingModals) {
      selectedOffer.value = null
    }
    createOfferMode.value = ''
    isCreateOfferOpen.value = false
  }

  const closeSuggestionsModal = () => {
    isSuggestionsOpen.value = false
  }

  const openCreateOfferFromHomepage = () => {
    createOfferMode.value = 'create'
    newOfferModalSource.value = 'homePage'
    isCreateOfferOpen.value = true
  }

  const openCreateOfferFromNotification = () => {
    createOfferMode.value = 'create'
    newOfferModalSource.value = 'notification'
    isCreateOfferOpen.value = true
  }

  return {
    isRemoveOfferOpen,
    createOfferMode,
    isCreateOfferOpen,
    selectedOffer,
    categoryNames,
    newOfferModalSource,
    suggestionsModalSource,
    isSuggestionsOpen,
    openRemoveOfferModal,
    closeRemoveOfferModal,
    openEditOffer,
    selectOffer,
    closeSuggestionsModal,
    closeCreateOfferOpen,
    openCreateOfferFromHomepage,
    openCreateOfferFromNotification,
  }
}
